import {roundToPenny} from '../vendor-orders/round-to-penny.js'
import {salesPrice, quantity, accountName, date, _repName} from './unminify'

const sumShipped = (invoices, defaultAccount) => {
  return sumInvoicesOfType(invoices, 'shipped', true, defaultAccount);
}

const sumShippedDollar = (invoices, defaultAccount, fromDate, toDate) => {
  return sumInvoicesOfType(invoices, 'shipped', false, defaultAccount, fromDate, toDate)
}

const sumSalesOrders = (invoices, defaultAccount, fromDate, toDate, rep) => {
  return sumInvoicesOfType(invoices, 'sales order', true, defaultAccount, fromDate, toDate, rep);
}

const sumSalesOrdersDollar = (invoices, defaultAccount, fromDate, toDate, rep) => {
  return sumInvoicesOfType(invoices, 'sales order', false, defaultAccount, fromDate, toDate, rep)
}

const sumHold = (invoices, defaultAccount, fromDate, toDate, rep) => {
  return sumInvoicesOfType(invoices, 'hold', true, defaultAccount, fromDate, toDate, rep);
}

const sumHoldDollar = (invoices, defaultAccount) => {
  return sumInvoicesOfType(invoices, 'hold', false, defaultAccount);
}

const sumWorksheet = (invoices, defaultAccount) => {
  return sumInvoicesOfType(invoices, 'worksheet', true, defaultAccount);
}

const sumWorksheetDollar = (invoices, defaultAccount) => {
  return sumInvoicesOfType(invoices, 'worksheet', false, defaultAccount);
}

const sumInvoicesOfType = (invoices, invoiceType, qtyOrDollar, defaultAccount, fromDate, toDate, rep) => { //qtyOrDollar = true for quantity false for dollar
  //type can be "shipped", "sales order", "hold", "worksheet"
  if (typeof invoices === "undefined") { return 0; }

  var result = 0;
  for (var i=0; i<invoices.length; i++) {
    let invoice = invoices[i];

    let addToTotal = false;

    switch(invoiceType) {
      case "shipped":
        addToTotal = true;

        break;
      case "sales order":
        if (!invoice.hold && !invoice.worksheet) {
          addToTotal = true;
        }

        break;
      case "hold":
        if (!!invoice.hold) {
          addToTotal = true;
        }

        break;
      case "worksheet":
        if (!!invoice.worksheet) {
          addToTotal = true;
        }

        break;
      default:
        //nothing
    }

    //check for default account
    if (defaultAccount.length > 0 && !defaultAccount.includes(accountName(invoice))) {
      addToTotal = false
    }

    if (rep != null && rep != 'All' && _repName(invoice) != rep) {
      addToTotal = false
    }

    if (fromDate != null && date(invoice) < fromDate) {
      addToTotal = false
    }

    if (toDate != null && date(invoice) > toDate) {
      addToTotal = false
    }

    if (addToTotal) {
      if (qtyOrDollar) {
        result += Number(quantity(invoice));
      } else {
        result += roundToPenny(Number(quantity(invoice)) * Number(salesPrice(invoice)));
      }
    }
  }

  return result;
}

export {sumShipped, sumShippedDollar, sumSalesOrders, sumSalesOrdersDollar, sumHold, sumHoldDollar, sumWorksheet, sumWorksheetDollar, roundToPenny}
